export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11255_OPEN_TASK_LIST': 'Open task list'
};
